import { createSelector } from '@reduxjs/toolkit';
import { getLastMessageId, getTradingMessages } from 'src/store/utils/bots';
import type { TradingState } from 'src/store/shared/tradingBots/types';

export interface Store {
  loans: {
    bot: TradingState;
  };
}

const selectorTradingGroupList = (state: Store) => state.loans.bot.groupList;
const selectorTradingSessionCreateStatus = (state: Store) => state.loans.bot.sessionCreateStatus;
export const selectorTradingSessionDetails = (state: Store) => state.loans.bot.sessionDetails;
export const selectorTradingGroupListIsPending = (state: Store) =>
  state.loans.bot.groupListStatus === 'pending';
export const selectorTradingMessageStatus = (state: Store) => state.loans.bot.messageStatus;

export const selectorTradingGroupOptions = createSelector(selectorTradingGroupList, (groupList) =>
  (groupList ?? []).map(({ id, name }) => ({ value: String(id), label: name })),
);

export const selectorIsSessionActive = createSelector(
  selectorTradingSessionCreateStatus,
  selectorTradingSessionDetails,
  (status, sessionDetails) => status === 'success' && sessionDetails !== null,
);

export const selectorTradingMessageLog = (state: Store) => state.loans.bot.messageLog;

export const selectorTradingMessages = createSelector(
  selectorTradingMessageLog,
  selectorTradingSessionDetails,
  getTradingMessages,
);

export const selectorTradingLastMessageId = createSelector(
  (state: Store) => state.loans.bot.messageLog,
  getLastMessageId,
);
